import { useState } from "react";

import { useNavigate } from "react-router-dom";

import { MFAChallenge } from "./MFAChallenge";
import { useAuthContext } from "../../../../hooks";

export function MFAChallengeContainer() {
  const {
    mfaChallenge,
    verifyMFA,
    clearMfaChallenge,
    isLoading,
    loginErrorMsg,
  } = useAuthContext();
  const navigate = useNavigate();
  const [code, setCode] = useState("");

  const handleVerify = () => {
    if (code.length === 0) return;
    verifyMFA(code);
  };

  const handleBackToLogin = () => {
    clearMfaChallenge();
    navigate("/login");
  };

  if (!mfaChallenge) {
    navigate("/login");
    return null;
  }

  return (
    <MFAChallenge
      destination={mfaChallenge.destination}
      code={code}
      onCodeChange={setCode}
      onVerify={handleVerify}
      onBackToLogin={handleBackToLogin}
      loading={isLoading}
      error={loginErrorMsg}
    />
  );
}
